import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiHash, FiFileText, FiPackage } from 'react-icons/fi';
import FormLayout, { SubmitBtn } from '../../ui/FormLayout';
import { InputField } from '../../ui/InputField';

const CadastrarUnidade = () => {
    const [sigla, setSigla] = useState('');
    const [descricao, setDescricao] = useState('');
    const navigate = useNavigate();
    const parametro = useParams();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    const handleSubmit = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "sigla": sigla, "descricao": descricao })
        };
        fetch(Apis.urlCadastrarUnidades, requestOptions)
            .then(response => response.json())
            .then((result) => {
                if (result.retorno.sucesso) {
                    if (parametro.id === '0') navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-unidades`);
                    else if (parametro.id === '1') navigate(`/alerta-sucesso/${result.retorno.mensagem}&cadastrar-produtos`);
                    else navigate(`/alerta-sucesso/${result.retorno.mensagem}&alterar-produto`);
                } else {
                    alertaErro(result.retorno.mensagem);
                }
            });
    };

    return (
        <FormLayout
            title="Cadastro de Unidade"
            icon={<FiPackage />}
            subtitle="Informe a sigla e descrição da unidade."
        >
            <InputField
                label="Sigla" icon={<FiHash />} required
                placeholder="Ex: KG, UN, PC"
                onChange={e => setSigla(e.target.value)} value={sigla}
            />
            <InputField
                label="Descrição" icon={<FiFileText />}
                placeholder="Descrição da unidade"
                onChange={e => setDescricao(e.target.value)} value={descricao}
            />
            <SubmitBtn onClick={handleSubmit}>Cadastrar Unidade</SubmitBtn>
        </FormLayout>
    );
};

export default CadastrarUnidade;
